// extracted by mini-css-extract-plugin
export default {"time_box":"Air_time_box__aaeMG","time_label":"Air_time_label__5hKkQ","chart_wrapper":"Air_chart_wrapper__kPSqb"};